var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex flex-column h-100 container"},[_c('loading',{ref:"loading"}),_vm._v(" "),_c('local-error',{attrs:{"inline":[]}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }